// Cookie domain shared across *.recleague.com (and *.recleague.com.localhost in
// dev). Returns null for custom domains, where callers should fall back to a
// host-only cookie.
//
// Scoping to the parent domain matters for anything written on rec-league pages:
// every league is its own subdomain, so a host-only cookie is re-written per
// league and the cumulative cookie header grows without bound. That has already
// caused HTTP 431 (Request Header Fields Too Large) once — see
// `cleanupStaleShowDraftsCookies` in `draftVisibility.ts`.
const SHARED_SUFFIXES = ["recleague.com.localhost", "recleague.com"];

export function sharedCookieDomain(): string | null {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  for (const suffix of SHARED_SUFFIXES) {
    if (host === suffix || host.endsWith(`.${suffix}`)) return `.${suffix}`;
  }
  return null;
}

/** `; domain=...` fragment for a cookie string, empty when host-only. */
export function cookieDomainAttribute(): string {
  const domain = sharedCookieDomain();
  return domain ? `; domain=${domain}` : "";
}

/** `; secure` fragment, applied only over HTTPS so dev on http still works. */
export function cookieSecureAttribute(): string {
  if (typeof window === "undefined") return "";
  return window.location?.protocol === "https:" ? "; secure" : "";
}
